/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminBrand.css';
import Calendar from '../../components/Calendar'
import Link from '../../components/Link'
import BrandComplete from '../../components/BrandComplete'
import AdminBackNav from '../adminBackNav/adminBackNav'

const typeList=[
  {
    class:'全部账号',
    type:0
  },{
    class:'试用账号',
    type:1
  },{
    class:'正式账号',
    type:2
  },{
    class:'管理员',
    type:3
  }
]
const platformList=[
  {
    type:'all',
    class:'所有平台'
  },{
    type:'wx',
    class:'微信'
  },{
    type:'wb',
    class:'微博'
  },{
    type:'zh',
    class:'知乎'
  },{
    type:'tt',
    class:'头条'
  },{
    type:'qeh',
    class:'企鹅号'
  },{
    type:'shh',
    class:'搜狐号'
  },{
    type:'wyh',
    class:'网易号'
  },{
    type:'ydh',
    class:'一点号'
  },{
    type:'bjh',
    class:'百家号'
  },{
    type:'xlkdh',
    class:'新浪看点号'
  },{
    type:'dfh',
    class:'大风号'
  },{
    type:'xqh',
    class:'雪球号'
  },{
    type:'pph',
    class:'澎湃号'
  }
]
const tableTit=[
  'ID',
  '姓名',
  '手机号',
  '邮箱',
  '品牌',
  '职位',
  '注册时间',
  '到期时间',
  '账号类型',
  '备注'
]
const exportDataLabel=[
  {
    class:'DB值',
    type:'db'
  },{
    class:'DB值（单日）',
    type:'dbDay'
  },{
    class:'三维度值',
    type:'dimensions'
  },{
    class:'三维度值（单日）',
    type:'dimensionsDay'
  },{
    class:'KOL参与情况',
    type:'kolPa'
  },{
    class:'受众好感',
    type:'favorability'
  },{
    class:'口碑舆情图',
    type:'sensation'
  },
]

const renderBrandList=[
  {
    class:'品牌ID',
    type:'id'
  },{
    class:'品牌名称',
    type:'brandName'
  },{
    class:'品牌行业',
    type:'industry'
  },{
    class:''
  }
]



let treeData=[
  {
    name:'华为',
    children:[
      {
        name:'手机',
      },{
        name:'IT制造',
        children:[
          {
            name:'IT制造a'
          },{
            name:'IT制造b'
          }
        ]
      },{
        name:'电脑'
      }
    ]
  }
] 

class AdminBrand extends React.Component {
   
  constructor(){
    super()
    this.state={
      phone:'',
      email:'',
      name:'',
      brandName:'',
      nickWord:'',
      markWord:'',
      eliminateWord:'',
      data:{},
      newData:{},
      doChangeBrandInfo:false,
      value:'',
      timeStart:'',
      timeEnd:'',
      timeStartShow:false,
      timeEndShow:false,
      platform:'all',
      checkList:[],
      files:[],
      seaValue:'',
      seaCompleteItem:[],
      checkboxAc:'db',
      industryValue:'',
      addIndustry:false,
      nickValue:'',
      inValue:'',
      markValue:'',
      eliminateValue:'',
      inItem:'',


      // 新行业树
      treeData:[],
      brandWord:{},
      industryInfo:{},
      inAc:''
    }
    this.isCalendarCon=false

    this.saveToState=this.saveToState.bind(this)
    this.saveFile=this.saveFile.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.closeCalendarStart=this.closeCalendarStart.bind(this)
    this.closeCalendarEnd=this.closeCalendarEnd.bind(this)
    this.seaComplete=this.seaComplete.bind(this)
    this.handleSubmit=this.handleSubmit.bind(this)
    this.doChangeAddIndustry=this.doChangeAddIndustry.bind(this)
    this.addIndustryItem=this.addIndustryItem.bind(this)
    this.getIndustryWord=this.getIndustryWord.bind(this)
    
  }
  closeCalendarStart=(time)=>{
    this.setState({timeStart:time,timeStartShow:false})
  }
  closeCalendarEnd=(time)=>{
    this.setState({timeEnd:time,timeEndShow:false})
  }
  
  enCalendarCon=()=>{
    this.isCalendarCon=true
  }
  ovCalendarCon=()=>{
    this.isCalendarCon=false
  }

  saveFile=()=>{
    // 保存数据到本地
    const {data,timeStart,timeEnd,platform,checkboxAc}=this.state
    if(!timeStart||!timeEnd){
      alert('时间为必选！')
    }else{
      
      const url=`/dbrankCMS/saveBrandChartsData?brandName=${data['brandName']}&timeStart=${timeStart}&timeEnd=${timeEnd}&platform=${platform}&charts=${checkboxAc}`
      console.log('保存数据url =>',url)
    

      const a = document.createElement('a');
      a.textContent = 'download';
      a.download = 'filename';
      a.href =url;
      a.click();
    }
  
  }
  doChangeAddIndustry=()=>{
    //暂时取消 行业修改
    const {data,industryValue,newData,inItem}=this.state
    console.log('添加新行业')
    this.setState({addIndustry:false})


    if(!inItem||!industryValue){
      alert('必选包含行业跟行业关键词')
    }else{

      const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']}&newIndustry=${industryValue}&newIndustryWordItem=${inItem}`
      console.log(url)
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
      .then(response=>response.json())
      .then(data=>{
        console.log(data,'data')
        if(data.errorCode==0){
          alert('修改成功！')
          this.getBrandInfo(this.state.brandName)
          
        }else{
          alert('修改失败！')
        }
      
      })
      .catch(e=>{
        console.log('err',e)
      })

    }
  
  }

  seaComplete=(e)=>{
    const {value}=e.target
    this.setState({seaValue:value})
 
  }
 

  openUpload(){
    const {data}=this.state
    // console.log(data)
    
        const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']}`
        let formData=new FormData()
        let index=0;

        formData.append('filedata',this.state.files[0])
 
        console.log('shangchuan ',formData,url,this.state.files)
        
     
        const myInit = {
          credentials: 'include', 
          mode: 'cors',
          cache: 'no-cache',
          method:'POST',
          body:formData
        };
        fetch(url,myInit)
        .then(response=>response.json)
        .then(data=>{
          console.log('data',data)
          if(data.errorCode==0){
            alert('修改成功！')
            this.getBrandInfo(this.state.brandName)
        
          }else if(data.errorCode==1){
            alert('修改失败！')
          }else if(data.errorCode==2){
            alert('请重新登录')
          }else if(data.errorCode==3){
            alert('没有修改权限')
          }
        })
        .catch(e=>{
          console.log('err',e)
        })
  }
  handChange=(e)=>{
    e.preventDefault();
    let target=e.target
    let files = target.files;
    // console.log('startInput',files)

    this.setState({
      files:files
    })
  }


  saveToState=(e)=>{
    const {name,value}=e.target
    const {newData,industryValue,nickValue,markValue,eliminateValue,inItem}=this.state
    
    if(name=='industryValue'||name=='nickValue'||name=='inValue'||name=='inItem'||name=='eliminateValue'||name=='markValue'){
      this.setState({
        [name]:value
      })
    }else{
      newData[name]=value
      
    }
    this.setState({
      // [name]:value,
      newData
    })
  }
  componentDidMount() {
    // this.getBrandInfo()
  }
  getBrandInfo=(brand)=>{
    // const {phone,email,name,brandName,accountType,timeStart,timeEnd}=this.state
    // const url=`/getAccountList?registerStart=${timeStart}&registerEnd=${timeEnd}&type=${accountType}&phone=${phone}&email=${email}&name=${name}&brand=${brandName}`
    // const url=`/dbrankCMS/getBrandInfo?brandName=${brand||''}`
    const url=`/dbrankCMS/getBrandInfo?brandName=${brand||''}`

    // this.setState({brandName:brand})
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      // console.log(data,'data')

      
      this.setState({
        data:data,
        // newData:data
        brandWord:data.word,
        
        brandName:data.brandName?data.brandName:data.name||'',
        treeData:[].concat(data.treeDate),
        inAc:data.brandName
        
      })
      if(data.errorCode==404){
        this.setState({data:[],newData:[]})
        alert('请输入正确品牌')
        
      }

      if(data.errorCode==2){
        alert('请重新登录！')
      }
    })
    .catch(e=>{
      console.log('err',e)
      this.setState({data:[],newData:[]})
      alert('请输出正确品牌')
    })

 



  }
  handleSubmit=(brand)=>{
    // e.preventDefault()
    // this.getBrandInfo(this.state.seaValue)
    // this.setState({})
    // console.log(typeof(brand),brand)
    if(typeof(brand)==='object'){
      alert('请输入正确品牌')
    }else{
      this.getBrandInfo(brand)
      
    }
   
    
  }
  addNick=()=>{
    //新增搜索关键词
    const {nickValue,data,newData}=this.state
    newData['nickWord'].push(nickValue)

    const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&newNickWord=${nickValue}`
    // const url=`http://10.0.58.22:8082/doChangeBrandInfo?brandName=${data['name']||''}`


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')

      if(data.errorCode==0){
        alert('修改成功！')
        this.getBrandInfo(this.state.brandName)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    
    })
    .catch(e=>{
      console.log('err',e)
    })

  }
  addIndustryItem=(index)=>{
    //添加行业关键词组
    const {newData,inValue,data}=this.state
    console.log(index,newData['industry'],inValue)
    newData['industry'][index]['industryWord'].push(inValue)
    let aa=newData['industry'][index]['name']
    const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&newIndustryWordItem=${inValue}&industry=${aa}`
    // const url=`http://10.0.58.22:8082/doChangeBrandInfo?brandName=${data['name']||''}`


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      if(data.errorCode==0){
        alert('修改成功！')
        this.getBrandInfo(this.state.brandName)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    
    })
    .catch(e=>{
      console.log('err',e)
    })
    
  }
  addMark=()=>{
    // 新增打标签关键词 
    const {newData,markValue,data}=this.state
    
    const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&newMarkWord=${markValue}`
    // const url=`http://10.0.58.22:8082/doChangeBrandInfo?brandName=${data['name']||''}`


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      if(data.errorCode==0){
        alert('修改成功！')
        this.getBrandInfo(this.state.brandName)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    
    })
    .catch(e=>{
      console.log('err',e)
    })
  }
  addElimin=()=>{
    //新增排除关键词
    const {newData,eliminateValue,data}=this.state
    
    const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&newEliminWord=${eliminateValue}`
    // const url=`http://10.0.58.22:8082/doChangeBrandInfo?brandName=${data['name']||''}`


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      if(data.errorCode==0){
        alert('修改成功！')
        this.getBrandInfo(this.state.brandName)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    })
    .catch(e=>{
      console.log('err',e)
    })
  }
  doChangeBrandName=()=>{
    //修改品牌名字
    const {newData,eliminateValue,data}=this.state
    
    const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&newBrandName=${newData['name']}`
    // const url=`http://10.0.58.22:8082/doChangeBrandInfo?brandName=${data['name']||''}`


    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')
      if(data.errorCode==0){
        alert('修改成功！')
        this.getBrandInfo(this.state.brandName)
        
      }else if(data.errorCode==1){
        alert('修改失败！')
      }else if(data.errorCode==2){
        alert('请重新登录')
      }else if(data.errorCode==3){
        alert('没有修改权限')
      }
    
    })
    .catch(e=>{
      console.log('err',e)
    })
  }
  deleteNick=(word)=>{
    const {data}=this.state
    console.log(word)
    if(confirm(`确认删除搜索关键词 ${word}`)){

      const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&deleteNickWord=${word}`
  
      console.log(url)
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
      .then(response=>response.json())
      .then(data=>{
        console.log(data,'data')

        if(data.errorCode==0){
          alert('修改成功！')
          this.getBrandInfo(this.state.brandName)
          
        }else if(data.errorCode==1){
          alert('修改失败！')
        }else if(data.errorCode==2){
          alert('请重新登录')
        }else if(data.errorCode==3){
          alert('没有修改权限')
        }
      
      })
      .catch(e=>{
        console.log('err',e)
      })
    }
  }
  deleteMark=(word)=>{
    const {data}=this.state
    console.log(word)
    if(confirm(`确认删除打标签关键词 ${word}`)){

      const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&deleteMarkWord=${word}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
      .then(response=>response.json())
      .then(data=>{
        console.log(data,'data')

        if(data.errorCode==0){
          alert('修改成功！')
          this.getBrandInfo(this.state.brandName)
          
        }else if(data.errorCode==1){
          alert('修改失败！')
        }else if(data.errorCode==2){
          alert('请重新登录')
        }else if(data.errorCode==3){
          alert('没有修改权限')
        }
      
      })
      .catch(e=>{
        console.log('err',e)
      })
    }
  }
  deleteElimin=(word)=>{
    const {data}=this.state
    console.log(word)
    if(confirm(`确认删除排除关键词 ${word}`)){

      const url=`/dbrankCMS/doChangeBrandInfo?id=${data['id']||''}&deleteEliminWord=${word}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
      .then(response=>response.json())
      .then(data=>{
        console.log(data,'data')

        if(data.errorCode==0){
          alert('修改成功！')
          this.getBrandInfo(this.state.brandName)
          
        }else if(data.errorCode==1){
          alert('修改失败！')
        }else if(data.errorCode==2){
          alert('请重新登录')
        }else if(data.errorCode==3){
          alert('没有修改权限')
        }
      
      })
      .catch(e=>{
        console.log('err',e)
      })
    }
  }


  getIndustryWord=(industry,level)=>{
    const {brandName}=this.state
    let url
    if(level==1){
      this.getBrandInfo(brandName)
      return 
    }else{
      url =`/dbrankCMS/getIndustryInfo?areaIndustry=${industry}&brandName=${brandName}`
    }
    console.log(url,'fetch industryInfo')

    // const url=`/dbrankCMS/getIndustryInfo?brandName=${brand||''}&areaIndustry=${industry}`
    
    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
    .then(response=>response.json())
    .then(data=>{
      console.log(data,'data')

      
      // let data={
      //   industry:industry,
      //   industryMark:[`${industry}手机`,`${industry}大手机`,`${industry}破手机`,`${industry}好好好`],
      //   industryElimate:[`${industry}凉凉`,`${industry}heihei`]
      // }
      this.setState({
        industryInfo:data,
        inAc:industry,
      })
      if(data.errorCode==404){
        this.setState({data:[],newData:[]})
        alert('请输入正确品牌')
      }
      if(data.errorCode==2){
        alert('请重新登录！')
      }
    })
    .catch(e=>{
      console.log('err',e)
      this.setState({data:[],newData:[]})
      alert('请输出正确品牌')
    })
    
    
    
  }

  render() {
    const {brandWord,brandName,treeData,inAc,industryInfo,markValue,eliminateValue,inValue,nickValue,checkboxAc,addIndustry,data,doChangeBrandInfo,nickWord,markWord,eliminateWord,name,newData,seaValue,value,platform,timeEnd,timeStart,inItem,timeStartShow,timeEndShow,industryValue}=this.state
    // console.log(data,data.length)
    
    return (
      <div className={s.root}>
        <AdminBackNav></AdminBackNav>
        <div className={s.container}>
          <h1>品牌管理</h1>
          <div className={s.seaItem}>

          {/* <form onSubmit={this.handleSubmit}>
            
            <input value={seaValue} onChange={this.seaComplete} className={s.seaInput}  />
          </form> */}
          </div>
          <div style={{height:'50px'}}>
          <BrandComplete value={seaValue} getBrand={this.handleSubmit}/>
          {/* <span onClick={this.handleSubmit} style={{lineHeight:'30px',}}>搜索</span> */}

          </div>
          <div className={s.listBox}>
            <ul className={s.labelList}>
              <li>
                <label>品牌ID</label>
                <span>{data.id||''}</span>
              </li>
              <li>
                <label>品牌名称</label>
                {doChangeBrandInfo
                ?<span>
                  <input type='text' value={newData['name']} name='name' onChange={this.saveToState} />
                  <i onClick={this.doChangeBrandName} className={s.addTure}>确认修改</i>
                  </span>
                :<span>{data['brandName']||''}</span>
                }
              </li>

              {treeData.length!=0&&<li>
                <label>行业树</label>
                <div className={s.clsTree}>
                  <ul>
                    {treeData&&treeData.map((i,index)=>
                      <li key={i.name} >
                        <span className={inAc==i.name?cx(s.levelone,s.ac):s.levelone} onClick={()=>this.getIndustryWord(i.name,1)} >
                          {i.name}
                        </span>
                        {i.children&&i.children.map((j,index)=>
                          <div key={j.name}  >
                            <span  className={inAc==j.name?cx(s.leveltwo,s.ac):s.leveltwo} onClick={()=>this.getIndustryWord(j.name,2)}>
                              {j.name}
                            </span>
                            {j.children&&j.children.map((q,index)=>
                              <div key={q.name} >
                                <span className={inAc==q.name?cx(s.levelthree,s.ac):s.levelthree} onClick={()=>this.getIndustryWord(q.name,3)}>
                                  {q.name}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </li>
                    )}
                  </ul>
                </div>
                <div className={s.industryInfo}>
                  <ul>
                    {inAc==brandName
                    ?<div>
                        <li>
                          搜索关键词
                          {brandWord.seaWord.map((i,index)=>
                            <span key={index} className={s.paddingItem}>{i}{doChangeBrandInfo&&<i onClick={()=>this.deleteNick(i)} className={s.delete}></i>}</span>
                        
                          )}
                          {doChangeBrandInfo&&
                          <div>
                            <input type='text' placeholder='添加新搜索关键词' value={nickValue} name='nickValue' onChange={this.saveToState}/>
                            <i onClick={this.addNick} className={s.addTure}>确认添加</i>  
                          </div>}
                        </li>
                        <li>
                          排除关键词
                          {brandWord.eliminateWord.map((i,index)=>
                            <span key={index} className={s.paddingItem}>{i}{doChangeBrandInfo&&<i onClick={()=>this.deleteNick(i)} className={s.delete}></i>}</span>
                          )}
                          {doChangeBrandInfo&&
                          <div>
                            <input type='text' placeholder='添加新排除关键词' value={eliminateValue} name='eliminateValue' onChange={this.saveToState}/>
                            <i onClick={this.addElimin} className={s.addTure}>确认添加</i>
                          </div>}
                        </li>  
                      </div>
                    :<div>
                      {industryInfo.industry!=brandName&&<li>行业：{industryInfo.industry}</li>}
                      {industryInfo.industry!=brandName&&<li>
                        行业标签关键词：
                        {industryInfo.industryMark&&industryInfo.industryMark.map((i,index)=>
                          <span key={index} className={s.paddingItem}>{i}{doChangeBrandInfo&&<i onClick={()=>this.deleteNick(i)} className={s.delete}></i>}</span>
                        )}
                        {doChangeBrandInfo&&
                        <div>
                          <input type='text' placeholder='添加新标签关键词' value={markValue} name='markValue' onChange={this.saveToState}/>
                          <i onClick={this.addMark} className={s.addTure}>确认添加</i>
                        </div>
                        }
                        
                      </li>}
                      {industryInfo.industry!=brandName&&<li>
                        行业排除关键词：
                        {industryInfo.industryElimate&&industryInfo.industryElimate.map((i,index)=>
                          <span key={index} className={s.paddingItem}>{i}{doChangeBrandInfo&&<i onClick={()=>this.deleteNick(i)} className={s.delete}></i>}</span>
                        )}
                        {doChangeBrandInfo&&
                        <div>
                          <input type='text' placeholder='添加新标签关键词' value={markValue} name='markValue' onChange={this.saveToState}/>
                          <i onClick={this.addMark} className={s.addTure}>确认添加</i>
                        </div>
                        }
                      </li>}
                    </div>}
                    
                  </ul>
                </div>
              </li>
              }
              {/* <li>
                <label>品牌行业</label>
                {doChangeBrandInfo
                ?<span>
                  {newData['industry']?
                    newData['industry'].map((i,index)=>
                      <span key={i.name} className={s.industryItem} >
                        <em className={s.paddingItem}>{i.name}</em>
                      </span>
                    ):null}
                  </span> 
                :<span>{data['industry']?data['industry'].map(i=>
                  <span key={i.name} className={s.industryItem} >
                      <em className={s.paddingItem}>{i.name}</em>
                    </span>)
                :''}</span>}
               
              </li>
              <li>
                <label>行业关键词</label>

                <ul>
                  {data['industry']?
                  data['industry'].map((i,index)=>
                    <li key={i.name}>
                      <i className={s.paddingItem}>{i.name}</i><em >{i.industryWord.map(j=><em key={j} className={s.smallItem}>{j}</em>)}</em>
                    </li>
                  ):null}
                </ul> 
             
              </li>
              <li>
                <label>搜索关键词：</label>
                {doChangeBrandInfo?
                  <span>
                  {data['nickWord']?
                    data['nickWord'].map((i,index)=>
                    <span key={index} className={s.paddingItem}>{i}<i onClick={()=>this.deleteNick(i)} className={s.delete}></i></span>
                  ):null}
                  <input type='text' placeholder='添加新搜索关键词' value={nickValue} name='nickValue' onChange={this.saveToState}/>
                  <i onClick={this.addNick} className={s.addTure}>确认添加</i>
                  </span>
                :<span>
                  {data['nickWord']?
                    data['nickWord'].map((i,index)=>
                    <span key={index} className={s.paddingItem}>{i}</span>
                  ):null}</span>}
              </li>
              <li>
                <label>打标签关键词：</label>
              

                {doChangeBrandInfo?
                  <span>
                  {data['markWord']?
                    data['markWord'].map(i=>
                    <span  key={i} className={s.paddingItem}>{i}<i onClick={()=>this.deleteMark(i)} className={s.delete}></i></span>
                  ):null}
                  <input type='text' placeholder='添加新标签关键词' value={markValue} name='markValue' onChange={this.saveToState}/>
                  <i onClick={this.addMark} className={s.addTure}>确认添加</i>
                  </span>
                :<span>
                  {data['markWord']?
                    data['markWord'].map(i=>
                    <span key={i} className={s.paddingItem}>{i}</span>
                  ):null}</span>}
              </li>
              <li>
                <label>排除关键词</label>
              
                {doChangeBrandInfo?
                  <span>
                  {data['eliminateWord']?
                    data['eliminateWord'].map(i=>
                    <span key={i} className={s.paddingItem}>{i}<i onClick={()=>this.deleteElimin(i)} className={s.delete}></i></span>
                  ):null}
                  <input type='text' placeholder='添加新排除关键词' value={eliminateValue} name='eliminateValue' onChange={this.saveToState}/>
                  <i onClick={this.addElimin} className={s.addTure}>确认添加</i>
                  </span>
                :<span>
                  {data['eliminateWord']?
                    data['eliminateWord'].map(i=>
                    <span key={i} className={s.paddingItem}>{i}</span>
                  ):null}</span>}
              </li> */}
              {
                doChangeBrandInfo?
                (<li>
                  <label>品牌LOGO</label>
                  <input name='file' type='file' onChange={(e)=>this.handChange(e,this)}/>
                  <span onClick={this.openUpload.bind(this)} className={s.addTure}>
                    上传logo
                  </span>

                  <div>
                    <label>品牌原LOGO：</label>
                    <span>{data['id']?<img src={`/digitalAssets/resources/img/LOGO/${data.id||''}.png`}/>:null}</span>
                  </div>
                  
                </li>)
                 :(<li>
                  <label>品牌原LOGO：</label>
                  <span>{data['id']?<img src={`/digitalAssets/resources/img/LOGO/${data.id||''}.png`}/>:null}</span>
                </li>)
              
              }
              
              

              <li>
                <div className={s.edit} onClick={()=>this.setState({doChangeBrandInfo:!this.state.doChangeBrandInfo})}>编辑</div>
                {doChangeBrandInfo?
                <div>
                {/* <div onClick={()=>this.setState({doChangeBrandInfo:true})}>提交</div> */}
                <div onClick={()=>this.setState({doChangeBrandInfo:false})}>取消</div>
                </div>
                :null
                }
                
              </li>
       

            </ul>
          </div>
          {data.length==0?null:
            <div>
              <h1>品牌数据信息</h1>
              <ul>
                <li>
                <div>
                <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeStartShow:false}):null}  tabIndex='0'>
                  <span className={s.timeInfoTxt}>发布时间：</span>
                  <div className={s.month} onClick={()=>this.setState({timeStartShow:!this.state.timeStartShow})}>
                      <span className={s.monthTxt} >
                        {timeStart}
                        {timeStart!=''?
                        <i className={s.monthTxtClose} onClick={()=>this.setState({timeStart:''})}>清空</i>
                        :null}
                      </span>
                  </div>
                  
                  <Calendar  isShow={timeStartShow} close={this.closeCalendarStart} cycle='日榜'
                      en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                  />
                </div>
                <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeEndShow:false}):null}  tabIndex='0'>
                  <span className={s.timeInfoTxt}>结束时间：</span>
                  <div className={s.month} onClick={()=>this.setState({timeEndShow:!this.state.timeEndShow})}>
                      <span className={s.monthTxt} >
                        {timeEnd}
                        {timeEnd!=''?
                        <i className={s.monthTxtClose} onClick={()=>this.setState({timeEnd:''})}>清空</i>
                        :null}
                      </span>
                  </div>
                  <div className={s.monthEnd}>
                    <Calendar  isShow={timeEndShow} close={this.closeCalendarEnd} cycle='日榜'
                        en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                    />
                  </div>
                </div>
              </div>
                </li>
                <li>
                  <label>选择平台：</label>
                  <select onChange={(e)=>this.setState({platform:e.target.value})}
                  value={platform}
                  >
                  {platformList.map(i=>
                    <option key={i.type} value={i.type}>{i.class}</option>
                  )}
                </select>
                </li>
                <li>
                  <label>勾选所需数据：</label>
                  <ul>
                    {
                      exportDataLabel.map((i,index)=>
                      <li key={i.class}>
                        <input name={i.class} type='checkbox' checked={checkboxAc==i.type?'checked':''}  value={i.class} onChange={()=>this.setState({checkboxAc:i.type})} />
                        <label>{i.class}</label>
                      </li>
                      )
                    }
                  </ul>
                </li>
                <div className={s.downLoad} onClick={this.saveFile}>点击导出数据</div>
                
              </ul>
            </div>
          }
            
        </div>
        
      </div>
    );
  }
}

export default withStyles(s)(AdminBrand);



// WEBPACK FOOTER //
// src/routes/adminBrand/AdminBrand.js